import { render, staticRenderFns } from "./SwitchColor.vue?vue&type=template&id=272ebca9&"
import script from "./SwitchColor.vue?vue&type=script&lang=js&"
export * from "./SwitchColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports